import { atom } from 'recoil'

import { DeleteAutoAssignModalProps } from './types'

const deleteAutoAssignModal: DeleteAutoAssignModalProps = {
  open: false,
  backofficeUserId: undefined,
  fullname: undefined,
}

const deleteAutoAssignModalAtom = atom({
  key: 'deleteAutoAssignModalAtom',
  default: deleteAutoAssignModal,
})

export default deleteAutoAssignModalAtom
